import { render, staticRenderFns } from "./FirmCreateOrUpdateInfo.vue?vue&type=template&id=2f21d7d2&scoped=true&"
import script from "./FirmCreateOrUpdateInfo.vue?vue&type=script&lang=js&"
export * from "./FirmCreateOrUpdateInfo.vue?vue&type=script&lang=js&"
import style0 from "./FirmCreateOrUpdateInfo.vue?vue&type=style&index=0&id=2f21d7d2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f21d7d2",
  null
  
)

export default component.exports